import { Navigate, Route, Routes } from 'react-router-dom';
import { SignedIn, SignedOut } from '@clerk/clerk-react';
import SignInPage from '@/app/auth/SignInPage';
import SignUpPage from '@/app/auth/SignUpPage';
import AccountPage from '@/app/account/AccountPage';
import NotFoundPage from '@/app/NotFoundPage';

const HomeRoute = () => (
  <>
    <SignedIn>
      <Navigate to="/account" replace />
    </SignedIn>
    <SignedOut>
      <Navigate to="/sign-in" replace />
    </SignedOut>
  </>
);

const SignInRoute = () => (
  <>
    <SignedIn>
      <Navigate to="/account" replace />
    </SignedIn>
    <SignedOut>
      <SignInPage />
    </SignedOut>
  </>
);

const SignUpRoute = () => (
  <>
    <SignedIn>
      <Navigate to="/account" replace />
    </SignedIn>
    <SignedOut>
      <SignUpPage />
    </SignedOut>
  </>
);

const AccountRoute = () => (
  <>
    <SignedIn>
      <AccountPage />
    </SignedIn>
    <SignedOut>
      <Navigate to="/sign-in" replace />
    </SignedOut>
  </>
);

const App = () => {
  return (
    <Routes>
      <Route path="/" element={<HomeRoute />} />
      <Route path="/sign-in/*" element={<SignInRoute />} />
      <Route path="/sign-up/*" element={<SignUpRoute />} />
      <Route path="/account/*" element={<AccountRoute />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default App;
